<template>
  <div>
    <b-navbar class="p-0" toggleable="sm" type="light" variant="light" v-if="layout === 'home' " 
    style="padding: 5px 0px 5px 0px !important;">
      <b-navbar-brand class="m-0 margins" style="padding-bottom: 0px !important;">
        <img
          class="logo"
          src="../assets/images/lntLogo.svg"
          data-aos="fade-in"
          @click="goToHomePage()"
        />
        <h4 class="partner-portal">PARTNER PORTAL</h4>
      </b-navbar-brand>
      <!-- <b-nav-form class="w-25">
        <b-input-group class="w-100">
          <b-input-group-text slot="prepend" class="search_bg border-0">
            <strong class="text-danger">
              <img class="search_img" src="../assets/images/search.svg" />
            </strong>
          </b-input-group-text>
        </b-input-group>
      </b-nav-form>-->

      <b-navbar-nav class="ml-auto">
        <b-button-group>
          <b-button
            variant="link"
            @click="goToLoginPage()"
            class="px-3 openSans-regular login-btn"
          >{{ $t('NAVIGATION_BAR.LOGIN') }}</b-button>
          <b-button
            variant="link"
            class="px-3 openSans-regular navbar_login"
            @click="goToRegisterPage()"
          >{{ $t('NAVIGATION_BAR.REGISTER') }}</b-button>
          <!-- <div class="social-login"> -->
          <!-- <span class="icon-style">
              <img src="@/assets/linkedin.svg" style="cursor: pointer" />
            </span>
            <span class>
              <img src="@/assets/facebook.svg" style="cursor: pointer" />
          </span>-->
          <!-- </div> -->
        </b-button-group>
      </b-navbar-nav>

      <!-- <b-navbar-toggle class="menu_style openSans-regular" target="nav-text-collapse">
        <img style="width: 26px" src="../assets/navbar.svg" />
      </b-navbar-toggle>-->
      <!-- <b-collapse id="nav-text-collapse" class="menu-nav-bg" is-nav>
        <b-navbar-nav>
          <div class="row navbar-menu-row ml-0 mr-auto source-sans-pro menu-item">
      
            <p slot="btn" class="p-4 mb-0 mt-1 pointer">{{ $t('NAVIGATION_BAR.HOME') }}</p>
         
            <dropdown class="p-4" :close-on-click="true">
              <template slot="btn">{{ $t('NAVIGATION_BAR.ABOUT_US') }}</template>
              <template slot="body">
                <ul class="pl-0">
                  <li class="drop-menu pointer">
                    <a href="#aboutLnt">Company Overview</a>
                  </li>
                  <li class="drop-menu pointer">
                    <a href="#partner">Partnership Avenues</a>
                  </li>
                  <li class="drop-menu pointer">
                    <a href="#ftrPrjct">Featured Projects</a>
                  </li>
                </ul>
              </template>
            </dropdown>

            <dropdown class="p-4" :close-on-click="true">
              <template slot="btn">{{ $t('NAVIGATION_BAR.PARTNER_PORTAL') }}</template>
              <template slot="body">
                <ul class="pl-0">
                  <li class="drop-menu pointer">
                    <a href="#mplace">Portal Overview</a>
                  </li>
                  <li class="drop-menu pointer" @click="goToDummyPage">Partner Portal</li>
                  <li class="drop-menu">
                    <a href="#Wpartner">Partner with L&T</a>
                  </li>
                  <li class="drop-menu">
                    <dropdown :x="15" :trigger="'hover'" :role="'sublist'" :align="'right'">
                      <template slot="btn">Partner Interface</template>
                      <template slot="body">
                        <ul class="pl-0" style="list-style: none;">
                          <li>
                            <span @click="goToRegisterPage()" class="pointer">Register</span>
                          </li>
                          <li class="pointer" @click="goToLoginPage()">On Board</li>
                          <li>
                            <a href="#performancemngmt">Performance Management</a>
                          </li>
                          <li>
                            <a href="#partnerfeedback">Feedback Questionnaire</a>
                          </li>
                        </ul>
                      </template>
                    </dropdown>
                  </li>
                  <li class="drop-menu">
                    <dropdown
                      :x="15"
                      :trigger="'hover'"
                      :role="'sublist'"
                      :align="'right'"
                      :close-on-click="true"
                    >
                      <template slot="btn">Partner Marketplace</template>
                      <template slot="body">
                        <ul>
                          <li>
                            <a href="#pricediscvry">Price Discovery</a>
                          </li>
                          <li>
                            <a href="#catalogue">Catalogue Management</a>
                          </li>
                          <li @click="goToEip()">Partner Bills & Payments</li>
                        </ul>
                      </template>
                    </dropdown>
                  </li>
                  <li class="drop-menu">
                    <dropdown :x="15" :trigger="'hover'" :role="'sublist'" :align="'right'">
                      <template slot="btn">Partner Management</template>
                      <template slot="body">
                        <ul>
                          <li @click="goToEmpanelment()">Empanelment</li>
                          <li>
                            <dropdown :x="15" :trigger="'hover'" :role="'sublist'" :align="'right'">
                              <li></li>
                              <template slot="btn">E-Sourcing</template>
                              <template slot="body">
                                <ul>
                                  <li @click="goToEip()">RFQ View</li>
                                  <li @click="goToEip()">Bid Submit</li>
                                </ul>
                              </template>
                            </dropdown>
                          </li>

                          <li @click="goToContractManagement()">Contract Management</li>
                          <li @click="goToEip()">ASN</li>
                          <li @click="goToEip()">PO / SO Acceptance</li>
                          <li>
                            <a
                              target="_blank"
                              href="https://xd.adobe.com/view/0e6b0642-76aa-4374-4467-2dbd313b89a3-785a/?fullscreen"
                            >Partner Status</a>
                          </li>
                        </ul>
                      </template>
                    </dropdown>
                  </li>
                  <li class="drop-menu">
                    <dropdown :x="15" :trigger="'hover'" :role="'sublist'" :align="'right'">
                      <template slot="btn">{{ $t('NAVIGATION_BAR.DASHBOARD') }}</template>
                      <template slot="body">
                        <ul class="pl-0">
                          <li>
                            <a
                              target="_blank"
                              href="https://xd.adobe.com/view/ae73340a-a47b-4958-662c-57adeeb36d8f-d842/screen/80f9c43f-28fb-462a-988e-88fe14833211/Web-1920-49?fullscreen"
                            >Partner</a>
                          </li>
                          <li class="drop-menu">Buyers</li>
                          <li class="drop-menu">Employees</li>
                          <li class="drop-menu">Senior Management</li>
                        </ul>
                      </template>
                    </dropdown>
                  </li>
                </ul>
              </template>
            </dropdown>
         
            <dropdown :close-on-click="true" class="p-4">
              <template slot="btn">{{ $t('NAVIGATION_BAR.FEEDBACK') }}</template>
              <template slot="body">
                <ul class="pl-0">
                  <li class="drop-menu">Suggestions & Feedback</li>
                  <li class="drop-menu pointer">
                    <a href="#testimonial">Testimonials</a>
                  </li>
                </ul>
              </template>
            </dropdown>
       
            <p slot="btn" class="p-4 mb-0">
              <a
                href="#footer"
                style="color:white;line-height:35px"
              >{{ $t('NAVIGATION_BAR.CONTACT_US') }}</a>
            </p>

          </div>
        </b-navbar-nav>
      </b-collapse>-->
    </b-navbar>
    <b-navbar
      class="p-0 empanel-main-header"
      toggleable
      type="light"
      variant="light"
      data-aos="zoom-in"
      v-if="layout === 'RegisterPage' || layout === 'ResetPassword' || layout === 'EmailVerification' "
    >
      <b-navbar-brand class="m-0 margins">
        <img
          class="logo"
          src="../assets/images/dashboardLogo.png"
          data-aos="fade-in"
          @click="goToHomePage()"
        />
      </b-navbar-brand>
    </b-navbar>
    <!-- Scrolling Message div -->
    <!-- <div class="scrooling-text-div">
      <b-alert class="p-0 m-0 p-2 alert" show dismissible>
        <marquee class="marquee">
          <p class="scrolling-text">
            <span
              class="scroll-message"
              v-for="scrollMessage in scrollMessages"
              :key="scrollMessage.messageId"
            >{{scrollMessage.message}}</span>
          </p>
        </marquee>
      </b-alert>
    </div> -->
  </div>
</template>

<script>
// import Dropdown from "bp-vuejs-dropdown";
import { DashboardService } from "../services/DashboardService";
const service = new DashboardService();

// const
export default {
  name: "Navbar",
  // components: { Dropdown },
  data() {
    return {
      // EIP_REDIRECR_URL : EIP_REDIRECR_URL,
      scrollMessages: [],
      alertPresent: true
    };
  },
  computed: {
    layout() {
      return this.$route.name;
    }
  },
  created() {
    // this.getScrollMessages();
  },
  methods: {
    closeAlert() {
      this.alertPresent = false;
    },
    goToRegisterPage() {
      this.$router.push("/registration");
    },
    goToLoginPage() {
      this.$router.push("/login");
    },
    goToHomePage() {
      if (this.$route.name == "EmailVerification") {
        // return;
        this.$router.push("/home");
      }
      if (this.$route.name == "ResetPassword") {
        this.$router.push("/login");
      } else {
        this.$router.push("/home");
      }
    },
    goToDashBoardPage() {
      this.$router.push("/dashboard");
    },
    closeDropdown() {
      // console.log(this.$refs);
      this.$refs["myDropdown"]._onBodyClick();
    },
    goToEip() {},
    goToEmpanelment() {
      window.location = process.env.VUE_APP_EMPANELMENT_REDIRECTLINK;
    },
    goToContractManagement() {
      window.location = process.env.VUE_APP_CONTRACT_MANAGEMENT_REDIRECT_LINK;
    },
    goToDummyPage() {
      this.$router.push("/designPage");
    },
    getScrollMessages() {
      var scrollMessageRequest = {
        listMessageTypeId: [1],
        loginAuditNumber: null
      };
      service
        .getScrollMessages(scrollMessageRequest)
        .then(res => {
          this.scrollMessages = res.response;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .navbar-height { */
/* height: 10vh !important; */
/* } */
.empanel-main-header {
  height: 70px;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
}
.logo {
  height: 2.5em;
  cursor: pointer;
}

.search_bg {
  background-color: #e7edf7;
}
.navbar_login {
  /* width: 9%;
  background: none;
  border-bottom: 0;
  border-top: 0;
  border-color: rgba(0, 0, 0, 0.16);
  border-radius: 0;
  color: #002d72;
  padding-left: 60.5px !important;
  padding-right: 60.5px !important; */
  /* padding-left: 60.5px !important; */
  padding-right: 60.5px !important;
  font-size: 16px;
  font-weight: 900 !important;
  text-align: left;
  color: #002d72;
}
.margins {
  object-fit: contain;
  margin-left: 2% !important;
}
.menu_style {
  height: 70px;
  font-size: 20px;
  border: none;
  border-radius: 0;
  /* background-color: #002d72; */
  color: #002d72 !important;
  outline: none;
  padding-left: 20px;
  padding-right: 20px;
}
.menu-nav-bg {
  background: #002d72;
}
.menu-item {
  font-size: 20px;
  line-height: 1.35;
  text-align: left;
  color: #ffffff !important;
}
.navbar-light .navbar-nav .nav-link {
  color: #ffffff !important;
  padding-top: 20px;
  padding-bottom: 20px;
}
.navbar-menu-row {
  margin: 0 auto auto auto !important;
}

.social-login {
  padding-right: 35px;
  border-right: 1px solid #00000020;
  border-left: 1px solid #00000020;
}

.icon-style {
  padding-left: 35px;
  padding-right: 30px;
}
.drop-menu {
  color: black;
  list-style-type: none !important;
  list-style: none !important;
}
.pointer {
  cursor: pointer;
}
ul {
  list-style: none;
  padding-left: 0px;
}
li {
  padding: 4px 8px;
  cursor: pointer;
  font-size: 18px;
}
/* li:hover {
  color: #007bff;
} */
a {
  color: black;
}
a:hover {
  text-decoration: none;
}
.partner-portal {
  font-size: 15px;
  display: block;
  left: 30px;
  position: relative;
  font-weight: 900;
  font-style: italic;
  top: -10px;
  color: #000000;
}
</style>
<style>
.menu-nav-bg .bp-dropdown__btn--active {
  background: #002d72 !important;
}
.menu-nav-bg .bp-dropdown__btn {
  border: 0px !important;
}
.menu-nav-bg .ul {
  padding-left: 0px !important;
}
.collapse:not(.show) {
  display: block !important;
}
.collapse show {
  display: none !important;
}
/* .scrooling-text-div > div > button {
  z-index: 1;
}
.alert {
  height: 40px;
}
.scrolling-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 2px;
  margin-top: -3px;
  padding: 0;
}
.scroll-message {
  padding-left: 5em;
} */
.login-btn{
      background-color: rgb(0, 86, 165) !important;
    color: #fff !important;
    padding: 5px 25px !important;
    padding-right: 25px !important;
    text-align: center !important;
    border-radius: 5px !important;
    font-size: 16px;
  font-weight: 900 !important;
}
</style>
